import * as React from 'react';
import { useForm } from 'react-hook-form';
import { styled } from 'styled-components';
import Tile from '../../common/Tile';
import { publicClientTypeSelectionPageUrl } from '../../../core/constants';
import Helmet from '../../../commonComponents/Helmet';
import PublicAutoLogoutLayout, {
	PublicHeaderLogo,
	PublicLogoWrapper,
	SubTitleParagraph,
	TitleParagraph
} from './common/PublicLayout';
import PublicForm from './common/PublicForm';
import { blackColour } from '../../cssConstants';
import heartSvg from '../../../images/heart.svg';
import StepInstructions from './common/PublicInstructionSteps';
import CheckboxField from '../../../commonComponents/fields/CheckboxField';
import { useProgress } from './common/PublicProgressContext';
import { ctxTermsAccepted } from './common/publicConstants';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';
import ExternalLink from '../../common/ExternalLink';
import { getPrivacyPolicyLink } from '../../../core/countryBasedConfig';

const PublicJoinPage = () => {
	const navigate = useNavigateWithAppName();
	const { updateProgress } = useProgress();
	const methods = useForm({
		defaultValues: {
			agreeWithTerms: false // Default value for the checkbox
		}
	});
	const isAgreeWithTermsChecked = methods.watch('agreeWithTerms');

	const handleContinueButtonClick = () => {
		updateProgress(ctxTermsAccepted, true);

		navigate(publicClientTypeSelectionPageUrl);
	};

	return (
		<PublicAutoLogoutLayout>
			<Helmet>
				<title>Join Kelly+Partners | Prospective Client</title>
			</Helmet>
			<Tile>
				<PublicLogoWrapper>
					<PublicHeaderLogo src={heartSvg} alt="Kelly+Partners Client" />
				</PublicLogoWrapper>
				<TitleParagraph $bold>Become a Kelly+Partners Client</TitleParagraph>
				<SubTitleParagraph>
					To become a Kelly+Partners client, please complete our short sign-up process.
				</SubTitleParagraph>
				<StepInstructions steps={steps} />
				<PublicForm
					methods={methods}
					onContinueButtonClick={handleContinueButtonClick}
					disabled={!isAgreeWithTermsChecked}
				>
					<StyledCheckbox label={<PublicDataPrivacyTerms />} name="agreeWithTerms" />
				</PublicForm>
			</Tile>
		</PublicAutoLogoutLayout>
	);
};

export default PublicJoinPage;

const PublicDataPrivacyTerms = () => (
	<>
		I have read and agree to my data being collected in accordance with the Kelly+Partners Accountants{' '}
		<ExternalLink href={getPrivacyPolicyLink()}>Privacy Policy</ExternalLink>.
	</>
);

const steps = [
	'Complete the sign-up form, sharing basic personal and business information.',
	'We’ll review your details and match you with the ideal office and Partner.',
	'The Partner will contact you within 24 hours to discuss next steps.'
];

const StyledCheckbox = styled(CheckboxField)`
	color: ${blackColour};

	.k-checkbox {
		margin-right: 10px;
	}
`;
